import { render, staticRenderFns } from "./SecuritySection.vue?vue&type=template&id=8d892c38&scoped=true&"
import script from "./SecuritySection.vue?vue&type=script&lang=js&"
export * from "./SecuritySection.vue?vue&type=script&lang=js&"
import style0 from "./SecuritySection.vue?vue&type=style&index=0&id=8d892c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d892c38",
  null
  
)

export default component.exports